<template>
  <div class="container">
    <Header class="is-uppercase has-text-weight-bold" />
    <slot></slot>
    <Footer class="is-uppercase has-text-weight-bold" />
  </div>
</template>

<script>
import Header from '@/components/LangKyf/Header'
import Footer from '@/components/LangKyf/Footer'

export default {
  name: 'LayoutHF',
  components: {
    Header,
    Footer
  }
}
</script>




// WEBPACK FOOTER //
// src/layouts/Kyf.vue